import { render, staticRenderFns } from "./UserAgedistribution.vue?vue&type=template&id=74936d67&scoped=true&"
import script from "./UserAgedistribution.vue?vue&type=script&lang=js&"
export * from "./UserAgedistribution.vue?vue&type=script&lang=js&"
import style0 from "./UserAgedistribution.vue?vue&type=style&index=0&id=74936d67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74936d67",
  null
  
)

component.options.__file = "UserAgedistribution.vue"
export default component.exports